export default{
    reparaciones: [],
    reparacionSelec: null
}